/**
 * Authorization Roles
 */
const authRoles = {
  1: ['0', '1', '2', '3', '4', '5', '6', '7'],
  2: ['2', '0'],
  3: ['3', '0'],
  4: ['4', '0'],
  5: ['5', '0'],
  6: ['6', '0'],
  7: ['7', '0'],
  onlyGuest: [],
};

export default authRoles;
